import { DRIVE_KEYS_PAGE_SIZE } from "services/orchid-drive/getDriveKeys";
import { calculateChunkCount } from "utils/calculateChunkCount";
import { acquireEntryKeysRequest } from "./downloadOrchidDriveFilesBFS";

export async function acquireEntryKeys(entryIds: string[]) {
  let combinedResults: Awaited<ReturnType<typeof acquireEntryKeysRequest>> = {};
  const chunkCount = calculateChunkCount(entryIds.length, DRIVE_KEYS_PAGE_SIZE);

  for (let chunkNum = 0; chunkNum < chunkCount; ++chunkNum) {
    const chunk = entryIds.slice(
      chunkNum * DRIVE_KEYS_PAGE_SIZE,
      (chunkNum + 1) * DRIVE_KEYS_PAGE_SIZE,
    );
    const result = await acquireEntryKeysRequest(chunk);
    combinedResults = { ...combinedResults, ...result };
  }
  return combinedResults;
}
